import actions from './actions';

const initState = {
    brand   : {},
    loading : false,
    errorMessage: null
};

export default function createOrUpdateBrandReducer(state = initState, action) {
    switch (action.type) {
        case actions.CREATE_OR_UPDATE_BRAND_REQUESTED:
            return {
                ...state,
                loading : true
            };
        case actions.CREATE_OR_UPDATE_BRAND_SUCCEEDED:

            return {
                ...state,
                brand   : action.brand,
                loading    : false
            };
        case actions.CREATE_OR_UPDATE_BRAND_FAILED:
            return {
                ...state,
                loading : false,
                errorMessage: action.error
            };
        default:
            return state;
    }
}
